export default "/images/fr.png?65d55189d27ad368ac099271a47983b4";